// src/main.tsx

// ✅ FIX: StrictMode is removed to prevent double-rendering issues with Turnstile.
// import { StrictMode } from 'react'; 
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { AnonymousUserProvider } from './context/AnonymousUserContext';
import { AudioPlayerProvider } from './context/AudioPlayerContext';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from '@/components/ThemeProvider';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Self-hosted fonts (replaces Google Fonts CDN links)
// EB Garamond
import '@fontsource/eb-garamond/400.css';
import '@fontsource/eb-garamond/500.css';
// Tiro Devanagari Sanskrit
import '@fontsource/tiro-devanagari-sanskrit/400.css';
import '@fontsource/tiro-devanagari-sanskrit/400-italic.css';
// Inter
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
// Cormorant Garamond (Koorma Chakra)
import '@fontsource/cormorant-garamond/300.css';
import '@fontsource/cormorant-garamond/400.css';
import '@fontsource/cormorant-garamond/600.css';
import '@fontsource/cormorant-garamond/700.css';
import '@fontsource/cormorant-garamond/300-italic.css';
// Rajdhani (Koorma Chakra)
import '@fontsource/rajdhani/300.css';
import '@fontsource/rajdhani/400.css';
import '@fontsource/rajdhani/500.css';
import '@fontsource/rajdhani/600.css';
import '@fontsource/rajdhani/700.css';
// Noto Sans Devanagari (Koorma Chakra + Ticker)
import '@fontsource/noto-sans-devanagari/300.css';
import '@fontsource/noto-sans-devanagari/400.css';
import '@fontsource/noto-sans-devanagari/500.css';
import '@fontsource/noto-sans-devanagari/600.css';
import '@fontsource/noto-sans-devanagari/700.css';
// IBM Plex Sans (Todo modal)
import '@fontsource/ibm-plex-sans/300.css';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/700.css';

import './index.css';
import './dark-mode.css';

createRoot(document.getElementById('root')!).render(
  // By removing <StrictMode>, the Turnstile script will only load once.
  <HelmetProvider>
    <ThemeProvider>
      <AnonymousUserProvider>
        <AudioPlayerProvider>
          <App />
        </AudioPlayerProvider>
      </AnonymousUserProvider>
    </ThemeProvider>
  </HelmetProvider>
);
